import { taxComplianceApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { PayrollTaxesGateway } from './PayrollTaxesGateway';
import type { TaxDepositResponse, TaxLiabilityResponse } from './types';

export class HttpPayrollTaxesGateway implements PayrollTaxesGateway {
  private readonly request = createJsonClient(taxComplianceApiBaseUrl);

  listLiabilities(signal?: AbortSignal): Promise<TaxLiabilityResponse[]> {
    return this.request('/api/tax-liabilities', undefined, signal);
  }

  calculateLiability(input: { formCode: number; taxYear: number; quarter: number | null }): Promise<TaxLiabilityResponse> {
    return this.request('/api/tax-liabilities', { method: 'POST', body: JSON.stringify(input) });
  }

  listDeposits(taxLiabilityId: string, signal?: AbortSignal): Promise<TaxDepositResponse[]> {
    return this.request(`/api/tax-liabilities/${taxLiabilityId}/deposits`, undefined, signal);
  }

  initiateDeposit(taxLiabilityId: string): Promise<TaxDepositResponse> {
    return this.request(`/api/tax-liabilities/${taxLiabilityId}/deposits`, { method: 'POST' });
  }

  checkDepositStatus(id: string): Promise<TaxDepositResponse> {
    return this.request(`/api/tax-deposits/${id}/check-status`, { method: 'POST' });
  }
}
